import { BarChart3 } from 'lucide-react';

export function ComparisonModal({ showComparison, setShowComparison, analysisResult, swingHistory }) {
  if (!showComparison || !swingHistory || swingHistory.length <= 1) return null;

  return (
    <div className="fixed inset-0 bg-black/90 backdrop-blur-sm flex items-center justify-center z-50 p-4">
      <div className="bg-gradient-to-br from-slate-900 to-black rounded-3xl max-w-4xl w-full max-h-[90vh] overflow-y-auto border border-white/10">
        <div className="sticky top-0 bg-slate-900 border-b border-white/10 p-6 flex justify-between items-center">
          <div>
            <h2 className="text-2xl font-bold flex items-center gap-2">
              <BarChart3 className="h-6 w-6 text-green-400" />
              Compare Swings
            </h2>
            <p className="text-slate-400 mt-1">See how you've improved over time</p>
          </div>
          <button
            onClick={() => setShowComparison(false)}
            className="text-slate-400 hover:text-white text-2xl w-10 h-10 flex items-center justify-center rounded-lg hover:bg-white/5"
          >
            ×
          </button>
        </div>

        <div className="p-6">
          {/* Current vs Previous */}
          <div className="grid grid-cols-1 md:grid-cols-2 gap-6 mb-8">
            {/* Current Swing */}
            <div className="bg-emerald-500/10 rounded-2xl p-6 border border-emerald-500/30">
              <div className="text-sm text-emerald-400 font-medium mb-2">CURRENT</div>
              <div className="text-5xl font-bold text-white mb-2">{analysisResult?.swingScore?.overall || analysisResult?.swingScore || '-'}</div>
              <div className="text-slate-400">{analysisResult?.swingGrade}</div>
              <div className="text-xs text-slate-500 mt-2">
                {new Date().toLocaleDateString()}
              </div>
            </div>

            {/* Previous Swing */}
            <div className="bg-white/5 rounded-2xl p-6 border border-white/10">
              <div className="text-sm text-slate-400 font-medium mb-2">PREVIOUS</div>
              <div className="text-5xl font-bold text-white mb-2">{swingHistory[1]?.swingScore || '-'}</div>
              <div className="text-slate-400">{swingHistory[1]?.swingGrade || '-'}</div>
              <div className="text-xs text-slate-500 mt-2">
                {swingHistory[1]?.date ? new Date(swingHistory[1].date).toLocaleDateString() : '-'}
              </div>
            </div>
          </div>

          {/* Change Indicator */}
          {(() => {
            const currentScore = analysisResult?.swingScore?.overall || analysisResult?.swingScore || 0;
            const prevScore = typeof swingHistory[1]?.swingScore === 'object'
              ? swingHistory[1]?.swingScore?.overall
              : swingHistory[1]?.swingScore;
            if (!currentScore || !prevScore) return null;
            const diff = currentScore - prevScore;
            return (
              <div className={`text-center p-4 rounded-xl mb-8 ${
                diff > 0 ? 'bg-emerald-500/20 border border-emerald-500/30'
                : diff < 0 ? 'bg-red-500/20 border border-red-500/30'
                : 'bg-white/5 border border-white/10'
              }`}>
                <div className={`text-3xl font-bold ${
                  diff > 0 ? 'text-emerald-400' : diff < 0 ? 'text-red-400' : 'text-slate-400'
                }`}>
                  {diff > 0 && '↑ '}{diff < 0 && '↓ '}{Math.abs(diff)} points
                </div>
                <div className="text-slate-400 text-sm mt-1">
                  {diff > 0 ? 'Great improvement!' : diff < 0 ? 'Keep practicing!' : 'Holding steady'}
                </div>
              </div>
            );
          })()}

          {/* Score History */}
          <div className="mb-6">
            <h3 className="text-lg font-bold mb-4">Score History</h3>
            <div className="space-y-2">
              {swingHistory.slice(0, 10).map((swing, idx) => (
                <div key={idx} className={`flex items-center justify-between p-3 rounded-xl ${idx === 0 ? 'bg-emerald-500/10 border border-emerald-500/30' : 'bg-white/5'}`}>
                  <div className="flex items-center gap-3">
                    <div className={`w-10 h-10 rounded-full flex items-center justify-center font-bold ${idx === 0 ? 'bg-emerald-500 text-black' : 'bg-white/10 text-white'}`}>
                      {swing.swingScore || '-'}
                    </div>
                    <div>
                      <div className="font-medium text-white">{swing.club || 'Unknown club'}</div>
                      <div className="text-xs text-slate-500">
                        {swing.date ? new Date(swing.date).toLocaleDateString() : 'Today'}
                      </div>
                    </div>
                  </div>
                  {idx === 0 && <span className="text-xs bg-emerald-500/20 text-emerald-400 px-2 py-1 rounded">Latest</span>}
                </div>
              ))}
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}
